function scrollToSliderActive() {
    let position = 0;
    let totalEl = 0
    document.querySelector('sub-colection').querySelectorAll('.tab-subcollection-item').forEach((item, index) => {
        if(item.querySelector('.button-tab-inner.active ')) {
            position = index;
        }
        totalEl = totalEl + item.offsetWidth;
    });

    window.swiper.slideTo(position, 100, true)
}

async function fetchSection(event) {
    let dataHref = event.target.dataset.href;
    
    // Display loading overlay
    showLoadingOverlay();

    // Fetch html
    let res = await fetch(dataHref);
    let doc = new DOMParser().parseFromString(await res.text(), "text/html");
    let allTabCollections = doc.querySelectorAll('.tab-subcollection-item')


    if (allTabCollections && allTabCollections.length > 0) {
        allTabCollections.forEach((tabItem) => {
            tabItem.classList.remove('active-cursor');
            tabItem.querySelector('.button-tab-inner').classList.remove('active');
            let currentTabHref = tabItem.dataset.href;
            if (currentTabHref == dataHref) {
                tabItem.querySelector('.button-tab-inner').classList.add('active');
                tabItem.classList.add('active-cursor');
            }
          });
    }
    document.querySelector('main').innerHTML = doc.querySelector('main').innerHTML;

    // Hide loading overlay after a delay
    setTimeout(hideLoadingOverlay, 1000);
    // Update URL
    window.history.pushState({ path: dataHref }, '', dataHref);
    // Init silder
    sliderInit();
    addScript();
}

window.addEventListener('popstate', function(event) {
    window.location.reload();
});

function addScript () {
    let script = document.createElement('script');
    script.src = 'https://iframe.patek.com/script.js';
    document.head.appendChild(script)
}

function showLoadingOverlay() {
    let overlay = document.createElement('div');
    overlay.classList.add('overlay', 'loading');
    overlay.innerHTML = `
        <div class="overlay__inner">
            <div class="overlay__content"><span class="spinner"></span></div>
        </div>
    `;
    document.querySelector('main').appendChild(overlay);
}

function hideLoadingOverlay() {
    let overlay = document.querySelector('.overlay.loading');
    if (overlay) {
        overlay.remove();
    }
}

function sliderInit(){
    var swiperMetafields = document.querySelector('.metafields-subcollection.swiper-container');
    window.swiper = new Swiper(swiperMetafields, {
        slidesPerView: 'auto',
        setWrapperSize: false,
        autoHeight: true,
        freeMode: true,
        grabCursor: true,
        mousewheel: {
            releaseOnEdges: true,
        }
    });
    scrollToSliderActive();
}
window.addEventListener('load', function () {
    sliderInit();
    scrollToSliderActive();
});